import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, CardTitle, Alert, Label, Input, Badge, FormGroup } from "reactstrap"
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ITEMS_PER_PAGE } from "helpers/pagination_helper";
import Loader from "common/loader";
import { PARTNERS_SEARCH } from "helpers/api_endpoints";
import Select from "react-select";
//meta title
document.title = "Partners";
const PartnersList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [userId, setUserId] = useState('');
    const [licenseFilePath, setLicenseFilePath] = useState(1);
    const [contractStartDate, setContractStartDate] = useState('');
    const [contractEndDate, setContractEndDate] = useState('');
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState(1);
    const [verifyType, setVerifyType] = useState(1);
    const [partners, setPartners] = useState([]);
    const [filters, setFilters] = useState({});
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [successMsg, setsuccessMsg] = useState('');

    const switchList = [{value:0, label:'All'}, {value:1, label:'Yes'}, {value:2, label:'No'}];

    useEffect(() => {
        successMessage();
        post(`${PARTNERS_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`, filters)
            .then(response => {
                const data = response.data;
                setPartners(data.data);
                setTotalPages(data.pagination.totalPages);
                setPage(data.pagination.currentPage);
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status == 400) {
                    console.log(error)
                }
            })
    }, [page, filters]);

    const successMessage = () => {
        if (location.state) {
            setsuccessMsg(location.state.successMsg);
            setTimeout(() => {
                location.state.successMessage = '';
                setsuccessMsg('');
            }, 4000)
        }
    };

    const handleFilter = (type, value) => {
        // Create a new filters object based on current filters
        const filtvalues = { ...filters };
        
        // If value is empty, remove that filter
        if (value === '') {
            delete filtvalues[type];
        } else {
            // Otherwise, update the filter
            switch (type) {
                case 'id':
                    setId(value);
                    filtvalues.id = value;
                    break;
                case 'name':
                    setName(value);
                    filtvalues.name = value;
                    break;
                case 'phoneNumber':
                    setPhoneNumber(value);
                    filtvalues.phoneNumber = value;
                    break;
                case 'contractStartDate':
                    setContractStartDate(value);
                    filtvalues.contractStartDate = value;
                    break;
                case 'contractEndDate':
                    setContractEndDate(value);
                    filtvalues.contractEndDate = value;
                    break;
                case 'status':
                    setStatus(value == 1 ? 2 : 1);
                    filtvalues.status = value;
                    break;
                case 'license':
                    setLicenseFilePath(value == 1 ? 2 : 1);
                    filtvalues.licenseFilePath = value;
                    break;
                case 'verifyType':
                    setVerifyType(value == 1 ? 2 : 1);
                    filtvalues.verifyType = value;
                    break;
                default:
                    break;
            }
        }
        
        setFilters(filtvalues);
    }

    const handlePrevPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleNextPage = () => {
        if (page < totalPages) {
            setPage(page + 1);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="Partners" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <br></br>
                                {successMsg ? <Alert style={{ margin: "25px" }} color="success">{successMsg}</Alert> : null}
                                <CardTitle>
                                    <Link to="/partners/add" >
                                        <button style={{ float: "right", marginRight: "20px" }} className="btn btn-sm btn-primary"><i className="dripicons-plus"></i> &nbsp;<Trans>Create</Trans></button>
                                    </Link>
                                </CardTitle>

                                <div style={{ margin: "25px" }}>
                                    <div className="row">
                                        <div className="form-group col-md-3 mt-2">
                                            <Label className="form-label"><Trans>ID</Trans></Label>
                                            <Input
                                                name="id"
                                                className="form-control"
                                                placeholder=""
                                                type="text"
                                                onChange={(e) => handleFilter('id', e.target.value)}
                                                onKeyDown={(e) => handleFilter('id', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-3 mt-2">
                                            <Label className="form-label"><Trans>Name</Trans></Label>
                                            <Input
                                                name="name"
                                                className="form-control"
                                                placeholder=""
                                                type="text"
                                                onChange={(e) => handleFilter('name', e.target.value)}
                                                onKeyDown={(e) => handleFilter('name', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-3 mt-2">
                                            <Label className="form-label"><Trans>Phone Number</Trans></Label>
                                            <Input
                                                name="phoneNumber"
                                                className="form-control"
                                                placeholder=""
                                                type="text"
                                                onChange={(e) => handleFilter('phoneNumber', e.target.value)}
                                                onKeyDown={(e) => handleFilter('phoneNumber', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-3 mt-2">
                                            <Label className="form-label"><Trans>Contract Start Date</Trans></Label>
                                            <Input
                                                name="contractStartDate"
                                                className="form-control"
                                                placeholder=""
                                                type="date"
                                                onChange={(e) => handleFilter('contractStartDate', e.target.value)}
                                                onKeyDown={(e) => handleFilter('contractStartDate', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-3 mt-2">
                                            <Label className="form-label"><Trans>Contract End Date</Trans></Label>
                                            <Input
                                                name="contractEndDate"
                                                className="form-control"
                                                placeholder=""
                                                type="date"
                                                onChange={(e) => handleFilter('contractEndDate', e.target.value)}
                                                onKeyDown={(e) => handleFilter('contractEndDate', e.target.value)}
                                            ></Input>
                                        </div>
                                        <div className="form-group col-md-3 mt-2">
                                                <Label className="form-label"><Trans>Status</Trans></Label>
                                                <Select
                                                                name="status"
                                                                value={switchList.find(el => el.value==status)}
                                                                options={switchList} 
                                                                className="form-control select2"
                                                                onChange={(e) => handleFilter('status',e.value)}
                                                            />                                        </div>
                                        <div className="form-group col-md-3 mt-2">
                                                <Label className="form-label"><Trans>License</Trans></Label>
                                                <FormGroup switch>
                                                <Input
                                                    type="switch"
                                                    size="md"
                                                    checked={licenseFilePath==2}
                                                    onClick={() => {
                                                        handleFilter('license', licenseFilePath);
                                                    }}
                                                    />
                                                </FormGroup>
                                        </div>
                                        <div className="form-group col-md-3 mt-2">
                                                <Label className="form-label"><Trans>Verification Type</Trans></Label>
                                                <FormGroup switch>
                                                <Input
                                                    type="switch"
                                                    size="md"
                                                    checked={verifyType==2}
                                                    onClick={() => {
                                                        handleFilter('verifyType', verifyType);
                                                    }}
                                                    />
                                                </FormGroup>
                                        </div>
                                    </div>
                                </div>


                                <CardBody>
                                    <div className="table-responsive">
                                        <Table className="table table-striped table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th><Trans>ID</Trans></th>
                                                    <th><Trans>Partner Name</Trans></th>
                                                    <th><Trans>Phone Number</Trans></th>
                                                    <th><Trans>Status</Trans></th>
                                                    <th><Trans>Trade License</Trans></th>
                                                    <th><Trans>Free verify</Trans></th>
                                                    <th><Trans>Contract Start Date</Trans></th>
                                                    <th><Trans>Contract End Date</Trans></th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? <tr><th colSpan={10} className="text-center"><Loader></Loader></th></tr> : null}
                                                {
                                                    partners.map((partner, index) => (
                                                        <tr key={index}>
                                                            <td>{partner.id}</td>
                                                            <td>{partner.name}</td>
                                                            <td>{partner.phoneNumber}</td>
                                                            <td>{<Badge className={partner.status==1?'bg-danger':'bg-success'}><Trans>{partner.status==1?'inactive':'active'}</Trans></Badge>}</td>
                                                            <td>{<Badge className={partner.licenseFilePath!=''?'bg-success':'bg-danger'}><Trans>{partner.licenseFilePath!=''?'Yes':'No'}</Trans></Badge>}</td>
                                                            <td>{<Badge className={partner.verifyType==2?'bg-success':'bg-danger'}><Trans>{partner.verifyType==2?'Yes':'No'}</Trans></Badge>}</td>
                                                            <td>{partner.contractStartDate}</td>
                                                            <td>{partner.contractEndDate}</td>
                                                            <td><Link to={`/partners/edit/${partner.id}`}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> &nbsp;<Trans>Edit</Trans></button></Link> &nbsp;
                                                                <Link to={`/partners/remove/${partner.id}`}><button className="btn btn-sm btn-danger" ><i className="dripicons-trash"></i> &nbsp;<Trans>Remove</Trans> </button></Link>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                    <br></br>
                                    <div className="text-center">
                                        {/* Pagination controls */}
                                        <button className="btn btn-sm btn-dark" onClick={handlePrevPage} disabled={page === 1}>
                                            <Trans>Previous</Trans>
                                        </button>&nbsp;
                                        <button className="btn btn-sm btn-dark" onClick={handleNextPage} disabled={page === totalPages}>
                                            <Trans>Next</Trans>
                                        </button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment >
    )
}

export default PartnersList
